import React, { Component } from "react";
import { Provider } from "react-redux";
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch,
} from "react-router-dom";
import store from "./store";
import "./App.css";
//import Landing from "./components/games/Landing";
import SupportHome from "./components/support/SupportHome";
import ServiceHome from "./components/service/ServiceHome";
import QuestionQuery from "./components/service/query/QuestionQuery";
import QuestionList from "./components/service/query/QuestionList";
import QuestionView from "./components/service/view/QuestionView";

import ReportQuestion from "./components/service/create/ReportQuestion";
import ConfirmIssue from "./components/service/create/ConfirmIssue";
import ReportHome from "./components/service/create/forms/ReportHome";
import EventSerial from "./components/events/EventSerial";
import EventDeliveroo from "./components/events/EventDeliveroo";
import Complete_agreement from "./components/policies/Complete_agreement";
import SurveyMain from "./components/survey/SurveyMain";
import SurveyLoginScreen from "./components/survey/SurveyLoginScreen";
import Survey2025G112 from "./components/survey/Survey2025G112";
import TestHome from "./components/test/TestHome";
import VipWireReportHome from "./components/vip/v2/VipWireReportHome";
import VipWireReportPortal from "./components/vip/v3/VipWireReportPortal";
import VipWireReportHomeV3 from "./components/vip/v3/VipWireReportHomeV3";
import VipNewebpayCode from "./components/vip/v3/VipNewebpayCode";
import VipResultV3 from "./components/vip/v3/VipResultV3";

import VipWireReportHomeSandbox from "./components/vip/v2/VipWireReportHomeSandbox";

import HelpScreen from "./components/pages/HelpScreen";

import FaqHome from "./components/faq/FaqHome";

import VipServiceHome from "./components/vipservice/VipServiceHome";
import VipQuestionQuery from "./components/vipservice/query/VipQuestionQuery";
import VipQuestionList from "./components/vipservice/query/VipQuestionList";
import VipQuestionView from "./components/vipservice/view/VipQuestionView";
import VipReportQuestion from "./components/vipservice/create/VipReportQuestion";

import ClickHome from "./components/click/ClickHome";

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <Router>
          <div className="App">
            <Switch>
              {/* <Route exact path="/" component={Landing} /> */}
              <Route exact path="/service_quick" component={ServiceHome} />
              <Route exact path={`/service/:game_id`} component={ServiceHome} />
              <Redirect
                from={`/wire_report/:game_id`}
                to={`/wire_report_v2/:game_id`}
              />
              {/* <Route exact path="/wire_report/:game_id" component={VipHome} /> */}
              <Route
                path={`/wire_report_v2/:game_id`}
                component={VipWireReportHome}
              />
              <Route
                path={`/wire_report_portal/:game_id`}
                component={VipWireReportPortal}
              />
              <Route
                path={`/wire_report_v3/:game_id`}
                component={VipWireReportHomeV3}
              />
              <Route
                path={`/wire_report_code`}
                component={VipNewebpayCode}
              />
              <Route
                path={`/wire_report_result`}
                component={VipResultV3}
              />
              <Route
                path={`/wire_report_v2_sandbox/:game_id`}
                component={VipWireReportHomeSandbox}
              />

              <Route exact path="/support" component={SupportHome} />
              <Route
                exact
                path="/service/:game_id/query"
                component={QuestionQuery}
              />
              <Route
                exact
                path="/service/:game_id/list"
                component={QuestionList}
              />

              <Route
                exact
                path="/service/:game_id/view/:q_id"
                component={QuestionView}
              />
              <Route
                exact
                path="/service/:game_id/create"
                component={ReportQuestion}
              />

              <Route
                exact
                path="/service/:game_id/confirm-issue"
                component={ConfirmIssue}
              />
              <Route
                exact
                path="/service/:game_id/report-issue"
                component={ReportHome}
              />

              <Route exact path="/vipservice" component={VipServiceHome} />
              <Route exact path={`/vipservice/:game_id`} component={VipServiceHome} />
              
              <Route
                exact
                path="/vipservice/:game_id/query"
                component={VipQuestionQuery}
              />
              <Route
                exact
                path="/vipservice/:game_id/list"
                component={VipQuestionList}
              />

              <Route
                exact
                path="/vipservice/:game_id/view/:q_id"
                component={VipQuestionView}
              />
              <Route
                exact
                path="/vipservice/:game_id/create"
                component={VipReportQuestion}
              />

              <Route
                exact
                path="/member/complete_agreement"
                component={Complete_agreement}
              />
              <Redirect
                from={`/member/privacy_agreement`}
                to={`/member/complete_agreement?site=long_e#privacy`}
              />

              <Route
                exact
                path="/events/event_serial"
                component={EventSerial}
              />
              <Route
                exact
                path="/events/deliveroo"
                component={EventDeliveroo}
              />

              <Route
                exact
                path="/survey/event18/:game_id"
                component={SurveyMain}
              />
              <Route
                exact
                path="/survey/2021/:game_id"
                component={SurveyLoginScreen}
              />
              <Route
                exact
                path="/survey/2025/racingmaster"
                component={Survey2025G112}
              />
              <Route exact path="/test/:t_id" component={TestHome} />
              <Route exact path="/help/home" component={HelpScreen} />

              <Route exact path="/faq" component={FaqHome} />

              <Route exact path="/click/:id" component={ClickHome} />
              
            </Switch>
          </div>
        </Router>
      </Provider>
    );
  }
}

export default App;
